export default __webpack_public_path__ + "static/media/basin.7610e542.png";